var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurface1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.945,
    height: 61,
    viewBox: "0 0 51.945 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M132.064,158.457a11.623,11.623,0,1,0,11.622,11.622A11.636,11.636,0,0,0,132.064,158.457Zm6.9,9.434-8.326,8.326a1.789,1.789,0,0,1-2.531,0l-3.182-3.182a1.79,1.79,0,1,1,2.531-2.531l1.916,1.916,7.061-7.061a1.79,1.79,0,0,1,2.531,2.531Zm0,0",
    transform: "translate(-106.091 -139.579)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M51.884,16.55l0-.047c-.027-.586-.044-1.206-.055-1.9A6.465,6.465,0,0,0,45.74,8.273C38.727,7.882,33.3,5.6,28.666,1.077l-.04-.038a3.9,3.9,0,0,0-5.306,0l-.04.038C18.645,5.6,13.22,7.882,6.206,8.274A6.465,6.465,0,0,0,.119,14.607c-.01.685-.028,1.3-.055,1.9l0,.11c-.136,7.152-.306,16.052,2.672,24.131A30.718,30.718,0,0,0,10.1,52.223a38.551,38.551,0,0,0,14.422,8.53,4.466,4.466,0,0,0,.591.161,4.365,4.365,0,0,0,1.716,0,4.48,4.48,0,0,0,.593-.162,38.576,38.576,0,0,0,14.406-8.535A30.761,30.761,0,0,0,49.2,40.735C52.189,32.632,52.02,23.715,51.884,16.55ZM25.972,45.7a15.2,15.2,0,1,1,15.2-15.2A15.219,15.219,0,0,1,25.972,45.7Zm0,0",
    transform: "translate(0)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurface1);
export default __webpack_public_path__ + "static/media/surface1.4cc032458ec75d68dcf8c79f22574f5e.svg";
export { ForwardRef as ReactComponent };